import { styled } from "@linaria/react";
import { colors } from "../../../../styles/utils/vars";
import { ButtonSmall } from "../../../ui/Button/StyledButton";
import { Paragraph12 } from "../../../ui/Typography/Typography";
export const StyledCharacter = /*#__PURE__*/styled('div')({
  name: "StyledCharacter",
  class: "StyledCharacter_s15euc0l"
});
export const Title = /*#__PURE__*/styled(Paragraph12)({
  name: "Title",
  class: "Title_t1anuaf8"
});
export const Value = /*#__PURE__*/styled(Paragraph12)({
  name: "Value",
  class: "Value_vniw8d1"
});
export const StyledProperties = /*#__PURE__*/styled('div')({
  name: "StyledProperties",
  class: "StyledProperties_s1linc9h"
});
export const Controls = /*#__PURE__*/styled('div')({
  name: "Controls",
  class: "Controls_c1ojl1i5"
});
export const Fake = /*#__PURE__*/styled('div')({
  name: "Fake",
  class: "Fake_fz72xqk"
});

require("./StyledProperties.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledProperties.tsx");